var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.28 22.1a20.93 20.93 0 0024.38 29 20.18 20.18 0 01-9.89 7.06c-10.92 3.53-22.72-2.73-26.36-14-3.64-11.27 2.26-23.24 13.18-26.77.71-.223 1.43-.407 2.16-.55a20.92 20.92 0 00-3.47 5.26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco.edd14d76.svg";
export { SvgF1ModeEco as ReactComponent };